import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue, usePostTitleEditor } from "eddev/blocks"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { twMerge } from "tailwind-merge"
import dayjs from "dayjs"
import { HeaderBrowse } from "@components/site/HeaderBrowse"
import { HeaderPrimary } from "@components/site/HeaderPrimary"
import page from "@views/page"
import { HeaderSecondary } from "@components/site/HeaderSecondary"
import { HeaderBasic } from "@components/site/HeaderBasic"
import { HeaderCarousel } from "@components/site/HeaderCarousel"

export const meta: BlockMeta = {
  title: "Page Header",
  inserter: false,
  postMetaBlock: {
    postTypes: ["page"],
    fieldName: "pageHeader",
  },
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("content/page-header", (props) => {
  return (
    <div className="w-full flex flex-col">
      {props.type === "browse" && (
        <HeaderBrowse
          theme={props.themed!}
          featuredImage={props.featuredImage!}
          hideShorts={!!props.miscSettings?.festivalSettings?.hideShorts}
        />
      )}
      {props.type === "primary" && (
        <HeaderPrimary
          title={props.page?.title || undefined}
          theme={props.themed!}
          featuredImage={props.featuredImage!}
          featuredText={props.featuredText || undefined}
        />
      )}
      {props.type === "secondary" && (
        <HeaderSecondary
          title={props.page?.title || undefined}
          theme={props.themed!}
          featuredImage={props.featuredImage!}
          links={props.links!}
        />
      )}
      {props.type === "carousel" && (
        <HeaderCarousel title={props.page?.title || undefined} theme={props.themed!} images={props.carouselImages!} />
      )}
      {props.type === "basic" && <HeaderBasic title={props.page?.title || undefined} />}
    </div>
  )
})
